import {
  FC,
  useContext,
  useEffect,
  useState,
  ChangeEvent,
  useRef,
} from "react";
import { useModalAction } from "../../components/modal-views/context";
import { EditIcon } from "../icons/edit-icon";
import Input_1 from "../ui/uploadInput";
import { useMutation } from "react-query";
import client from "../../api";
import {
  capitalizeEachFirstLetter,
  capitalizeFirstLetter,
  getCurrencyInfo,
  getErrorMessage,
  getStatusStyle,
  logger,
  makeNumberWithFloatingDigits,
} from "../../lib/utils";
import GlobalContext from "src/context/global-context";
import { useIsMounted } from "src/lib/hooks/use-is-mounted";
import { Form, InputNumber, Table } from "antd";
import {
  NetworkDisconnectMsg,
  APISomethingWrongMsg,
  LIST_PAGE_SIZE,
  SUCCESS_MODAL_TYPE,
} from "src/lib/constants";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import useAuth from "src/hooks/use-auth";
import Password from "../ui/password";
import Button from "../ui/button";
import { AdminUser } from "src/api/types";
import Input from "../ui/input";
import { PermissionDataType } from "src/lib/constants/table-type";
import ToggleSwitch from "../ui/switch";
import { ColumnsType } from "antd/es/table";
import { callback } from "chart.js/dist/helpers/helpers.core";
import { getValue } from "@mui/system";
import CurrencyDrop from "../ui/dropdown-list";
import { SpinnerIcon } from "../icons/spinner-icon";
interface IGroupedCategoryList {
  label: string;
  code: Number;
}

const schema = yup
  .object({
    service_id: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(1, "Id must be greater than 0")
      .required("Required Field"),

    service_name_en: yup
      .string()
      .trim()
      .matches(
        /^[a-zA-Z]+( [a-zA-Z]+)*$/,
        "Service Name must be at least two words, do not contain numbers and special symbols!"
      )
      .required("Required Field"),
    service_name_ge: yup
      .string()
      .trim()
      .matches(
        /^[\u10A0-\u10FF ]+$/,
        "Service Name must be at least two Georgian words and cannot include numbers or special symbols!"
      )
      .required("Required Field"),
    service_name_ru: yup
      .string()
      .trim()
      .matches(
        /^[\u10A0-\u10FF\u0400-\u04FF ]+$/,
        "Service Name must be at least two words, do not contain numbers and special symbols!"
      )
      .required("Required Field"),

    min_amount: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(0, "Must be at least 0")
      .required("Required Field"),
    max_amount: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(0, "Must be at least 0")
      .required("Required Field")
      .when(["min_amount"], ([min], schema) =>
        typeof min === "number"
          ? schema.min(
              min,
              "Maximum amount must be greater than or equal to minimum amount"
            )
          : schema
      ),
    is_active: yup.string().required("Field is Required"),
  })
  .required();

// type CategoryFormData = yup.InferType<typeof schema>;
type FormData = yup.InferType<typeof schema>;

type CategoryFormPageProps = {
  isNew: boolean;
  editingUser?: any;
  onCallback: any;
};

const ServiceFormPage: FC<CategoryFormPageProps> = ({
  isNew,
  editingUser,
  onCallback,
}) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const { openModal, closeModal } = useModalAction();

  const [dataSource, setDataSource] = useState<PermissionDataType[]>([]);

  dataSource.sort((a, b) => {
    if (a.id === 12 || a.id === 13) {
      return -1;
    }
    if (a.id === 13 || b.id === 12) {
      return 1;
    }
    return 0;
  });

  const { setIsAlertOpened, setAlertText } = useContext(GlobalContext);
  const isMounted = useIsMounted();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    reset,
    control,
    getValues,
    formState: { isValid, errors },
  } = useForm<FormData>({
    mode: "all",
    resolver: yupResolver(schema),
    defaultValues: {
      //   cat_id: -1,
      //   category_name_en: "",
      //   category_name_ge: "",
      //   category_name_ru: "",
      //   services_count: undefined,
      //   is_active: "",
    },
  });

  logger.log(isValid, "   IS VALID ", errors, "  ERRORS ");
  const isActive = watch("is_active");
  const [imagePreview, setImagePreview] = useState<string | undefined>("");
  const [imageFile, setImageFile] = useState<File | null>();
  const [catData, setCatData] = useState<any>([]);
  const [categories, setCategories] = useState<any>([]);
  const [categoriesList, setCategoriesList] = useState<IGroupedCategoryList[]>(
    []
  );
  const [selectCategory, setSelectedCategory] = useState<IGroupedCategoryList>({
    label: "All",
    code: -1,
  });
  const [localError, setLocalError] = useState<any>();

  const handleFile = (e: any) => {
    const file = e.target.files?.[0];
    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);
    setImageFile(file);
  };

  useEffect(() => {
    updateWindowSize();
    window.addEventListener("resize", updateWindowSize);

    return () => window.removeEventListener("resize", updateWindowSize);
  }, []);

  function updateWindowSize() {
    setIsMobile(window.innerWidth < 640 ? true : false);
  }

  logger.log(editingUser, "EDITINGUSER");

  useEffect(() => {
    const loadData = async () => {
      await getCategoriesList();
      if (editingUser) {
        fetchDetails(editingUser.key);
      }
    };

    loadData();
  }, [isNew, editingUser]);

  const { mutate: createNew, isLoading: isLoadingCreate } = useMutation(
    client.moneyMover.addService,
    {
      onSuccess: (data) => {
        logger.log(data);
        openModal("CATEGORY_SUCCESS_VIEW", {
          isNew,
          callback: onCallback,
          type: "service"
        });
      },
      onError: (error: any) => {
        if (error.code === "ERR_NETWORK") {
          setAlertText(NetworkDisconnectMsg);
        } else {
          if (error.response) {
            setAlertText(getErrorMessage(error.response.data));
          } else {
            setAlertText(APISomethingWrongMsg);
          }
        }
        setIsAlertOpened(true);
      },
    }
  );

  const { mutate: updateOne, isLoading: isLoadingUpdate } = useMutation(
    client.moneyMover.updateService,
    {
      onSuccess: (data) => {
        logger.log(data);
        openModal("CATEGORY_UPDATE_VIEW", {
          isNew,
          callback: onCallback,
          type: "service"
        });
      },
      onError: (error: any) => {
        if (error.code === "ERR_NETWORK") {
          setAlertText(NetworkDisconnectMsg);
        } else {
          if (error.response) {
            setAlertText(getErrorMessage(error.response.data));
          } else {
            setAlertText(APISomethingWrongMsg);
          }
        }
        setIsAlertOpened(true);
      },
    }
  );

  const { mutate: fetchDetails, isLoading: isLoadingFetchDetails } =
    useMutation(client.moneyMover.fetchsService, {
      onSuccess: (data: any) => {
        logger.log(data, "EDITINGF");
        let activeStatus = data.is_active === "Y" ? "yes" : "no";
        const category = categoriesList.find(
          (item) => item.code === data.cat_id
        );
        logger.log(category, "RRHJBHJIN");
        if (category) {
          setSelectedCategory(category);
        }
        setValue("service_name_ge", data.service_name[0], {
          shouldValidate: true,
        });
        setValue("service_name_ru", data.service_name[1], {
          shouldValidate: true,
        });
        setValue("service_name_en", data.service_name[2], {
          shouldValidate: true,
        });
        setValue("service_id", data.service_id, {
          shouldValidate: true,
        });
        setValue("is_active", activeStatus, { shouldValidate: true });
        setValue("min_amount", data.min_amount, {
          shouldValidate: true,
        });
        setValue("max_amount", data.max_amount, {
          shouldValidate: true,
        });

        setImagePreview(data.service_image);
      },
      onError: (error: any) => {
        if (error.code === "ERR_NETWORK") {
          setAlertText(NetworkDisconnectMsg);
        } else {
          if (error.response) {
            setAlertText(getErrorMessage(error.response.data));
          } else {
            setAlertText(APISomethingWrongMsg);
          }
        }
        setIsAlertOpened(true);
      },
    });

  const { mutateAsync: getCategoriesList, isLoading: categoriesLoading } =
    useMutation(client.categories.all, {
      onSuccess: (data) => {
        setCatData(data);
        const formattedCategoriesList: IGroupedCategoryList[] = [
          // {
          //   label: "All",
          //   code: null,
          // },
          ...data.map((category: any) => ({
            label: category.cat_name.at(-1),
            code: category.id,
          })),
        ];
        setCategoriesList(formattedCategoriesList);
        setCategories([
          // "All",
          ...data.map((item: any) => item.cat_name.at(-1)),
        ]);
      },
      onError: (error: any) => {
        if (error.code === "ERR_NETWORK") {
          setAlertText(NetworkDisconnectMsg);
        } else {
          if (error.response) {
            setAlertText(getErrorMessage(error.response.data));
          } else {
            setAlertText(APISomethingWrongMsg);
          }
        }
        setIsAlertOpened(true);
      },
    });

  const onValueChanged = (type: string, value: boolean) => {
    logger.log(type, value);
    const newData = [...dataSource];
    const index = newData.findIndex((item) => type == item.name);
    if (index > -1) {
      const item = newData[index];
      const editingData = { ...item, value };
      newData.splice(index, 1, {
        ...item,
        ...editingData,
      });
      setDataSource(newData);
    }
  };

  const onCancel = () => {
    onCallback(false);
  };

  const onSubmit = (data: FormData) => {
    if (isNew) {
      const formData = new FormData();
      let activeValue = isActive === "yes" ? "Y" : "N";
      let catId = selectCategory.code;
      formData.append("cat_id", catId.toString());
      formData.append("service_id", getValues("service_id").toString());
      if (imageFile) {
        formData.append("service_image", imageFile);
      }
      formData.append("min_amount", getValues("min_amount").toString());
      formData.append("max_amount", getValues("max_amount").toString());
      formData.append("is_active", activeValue.toString());
      let arr: string[] = [];

      Object.entries(data).forEach(([key, value]) => {
        if (key.includes("service_name")) {
          if (key === "service_name_en") {
            arr[2] = value.toString();
          } else if (key === "service_name_ge") {
            arr[0] = value.toString();
          } else if (key === "service_name_ru") {
            arr[1] = value.toString();
          }
        }
      });
      formData.append("service_name", arr?.toString());

      createNew(formData);
    } else {
      let activeValue = isActive === "yes" ? "Y" : "N";
      const formData = new FormData();
      let catId = selectCategory.code;
      formData.append("cat_id", catId.toString());
      formData.append("service_id", getValues("service_id").toString());
      if (imageFile) {
        formData.append("service_image", imageFile);
      }
        

      formData.append("min_amount", getValues("min_amount").toString());
      formData.append("max_amount", getValues("max_amount").toString());
      formData.append("is_active", activeValue.toString());
      let arr: string[] = [];
      Object.entries(data).forEach(([key, value]) => {
        if (key.includes("service_name")) {
          if (key === "service_name_en") {
            arr[2] = value.toString();
          } else if (key === "service_name_ge") {
            arr[0] = value.toString();
          } else if (key === "service_name_ru") {
            arr[1] = value.toString();
          }
        }
      });
      formData.append("service_name", arr?.toString());

        updateOne({
          id: editingUser.key,
          payload: formData,
        });
    }
  };

  const handleCategory = (value: string) => {
    // if (value === "All") {
    //   setSelectedCategory({
    //     label: "All",
    //     code: -1,
    //   });
    // } else {
      let findObj: any = categoriesList.find(
        (category: any) => category.label === value
      );
      let currCode = findObj.code;
      setSelectedCategory({
        label: value,
        code: currCode,
      });
    // }
    if (localError?.category) {
      setLocalError((prev: any) => ({
        ...prev,
        category: undefined,
      }));
    }
  };


  return (
    <>
      {categoriesLoading || isLoadingFetchDetails ? (
        <div className="flex justify-center items-center w-full h-full">
          <SpinnerIcon className="h-auto w-10 animate-spin" />
        </div>
      ) : (
        <form
          className="w-full h-full flex-col p-2 sm:p-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="w-full flex flex-row items-center justify-between">
            <p className="text-[25px] sm:text-[32px] font-manrope text-primary font-medium leading-[37.5px] sm:leading-[48px]">
              {isNew ? "Create New Service" : "Edit Service"}
            </p>
          </div>
          <div className="flex flex-col w-full bg-white rounded-[12px] p-4 mt-2 sm:mt-4">
            <div className="grid md:gap-[20px] gap-4 grid-cols-12"></div>

            <div className="grid md:gap-[20px] gap-4 grid-cols-12">
            
              <div
                className={` col-span-12 block
               `}
              >
                <p className="text-[16px] font-semibold font-manrope text-primary">
                  Service Image
                </p>
                <div className="border-[2px] relative border-dashed h-[100px] w-[100px] border-[#9e9e9e] rounded-[100px] mt-2 bg-[#f0f0f0]">
                  <Input_1
                    label=""
                    type="file"
                    id="imageFile"
                    className="w-full h-full absolute top-0 left-0 z-[9999] cursor-pointer opacity-0"
                    disabled={editingUser ? true : false}
                    onChange={handleFile}
                    // error={errors.cat_image && (errors.cat_image.message as string)}
                  />

                  {imagePreview ? (
                     <div className="flex items-center justify-between gap-2 h-full w-full">
                       <img
                         src={imagePreview}
                         alt=""
                         className="max-w-full h-full w-full object-cover rounded-full"

                       />
                      <EditIcon className="w-[20px] h-[20px] text-primary absolute right-[-5px] bottom-[-5px]" />
                      </div>
                  ) : (

                    <div className="flex items-center justify-center h-full flex-col">
                      <div className="text-center h-[38px] flex items-center justify-center cursor-pointer">
                        {Icon}
                      </div>
                      <div className="text-center"></div>
                    </div>
                  )}
                </div>
              </div>{" "}
              <div className="col-span-12">
                <p className="text-[20px] font-bold pb-3 font-manrope text-primary">
                  Service Name:
                </p>
                <div className="grid md:gap-[20px] gap-4 grid-cols-12">
                  {["Georgian", "Russian", "English"].map((item, key) => (
                    <div
                      key={key}
                      className="md:col-span-4 sm:col-span-6 col-span-12"
                    >
                      <p className="text-[16px] font-semibold font-manrope text-primary">
                        {item}
                      </p>
                      <Input
                        label=""
                        placeholder="Enter Category name"
                        className="w-full mt-2"
                        {...register(
                          item === "Georgian"
                            ? "service_name_ge"
                            : item === "Russian"
                            ? "service_name_ru"
                            : "service_name_en"
                        )}
                        error={
                          item === "Georgian"
                            ? (errors?.service_name_ge?.message as string)
                            : item === "Russian"
                            ? (errors?.service_name_ru?.message as string)
                            : (errors?.service_name_en?.message as string)
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className={`md:col-span-4 sm:col-span-6 col-span-12 `}>
                <p className="text-[16px] font-semibold font-manrope text-primary">
                  Service Id{" "}
                </p>
                <Input
                  label=""
                  type="number"
                  id="service_id"
                  className="w-full mt-2"
                  // disabled={editingUser ? true : false}
                  {...register("service_id")}
                  error={
                    errors.min_amount && (errors.min_amount.message as string)
                  }
                />
              </div>{" "}
          
              <div className={`md:col-span-4 sm:col-span-6 col-span-12 `}>
                <p className="text-[16px] font-semibold font-manrope text-primary">
                  Min Amount{" "}
                </p>
                <Input
                  label=""
                  type="number"
                  step={0.01}
                  id="min_amount"
                  className="w-full mt-2"
                  {...register("min_amount")}
                  error={
                    errors.min_amount && (errors.min_amount.message as string)
                  }
                />
              </div>{" "}
              <div className={`md:col-span-4 sm:col-span-6 col-span-12 `}>
                <p className="text-[16px] font-semibold font-manrope text-primary">
                  Max Amount{" "}
                </p>
                <Input
                  label=""
                  type="number"
                  id="max_amount"
                  className="w-full mt-2"
                  // disabled={editingUser ? true : false}
                  {...register("max_amount")}
                  error={
                    errors.max_amount && (errors.max_amount.message as string)
                  }
                />
              </div>{" "}
              <div className={`md:col-span-4 sm:col-span-6 col-span-12 `}>
                <p className="text-[16px] font-semibold font-manrope text-primary mb-2">
                  Select Category{" "}
                </p>
                <CurrencyDrop
                wrapperClass="h-[50px]"
                height={65}
                  // value={searchParams.channel_category.label}
                  value={selectCategory.label === "All" ? "Select Category" : selectCategory.label}
                  options={categories ? [...categories] : []}
                  onChange={handleCategory}
                  type="category"
                />
              </div>{" "}
              <div className={`md:col-span-4 sm:col-span-6 col-span-12 block`}>
                <p className="text-[16px] font-semibold font-manrope text-primary">
                  Status
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <div className="flex-1">
                    <label
                      className={`${
                        isActive == "yes"
                          ? "border-[#c3e600] bg-[#c3e600]"
                          : "border-[#ddd] bg-[#ddd]"
                      } flex items-center gap-1 h-[63px] text-[16px] font-semibold relative w-full justify-center border rounded-[10px] `}
                    >
                      <input
                        type="radio"
                        value="yes"
                        className="absolute top-0 left-0 w-full h-full z-[999] cursor-pointer opacity-0"
                        // disabled={!!editingUser}
                        {...register("is_active")}
                      />
                      Yes
                    </label>
                  </div>
                  <div className="flex-1">
                    <label
                      className={`${
                        isActive == "no"
                          ? "border-[#c3e600] bg-[#c3e600]"
                          : "border-[#ddd] bg-[#ddd]"
                      } flex items-center gap-1 h-[63px] text-[16px] font-semibold relative w-full justify-center border rounded-[10px] `}
                    >
                      <input
                        type="radio"
                        className="absolute top-0 left-0 w-full h-full z-[999] cursor-pointer opacity-0"
                        value="no"
                        // disabled={!!editingUser}
                        {...register("is_active")}
                      />
                      No
                    </label>
                  </div>
                </div>
              </div>{" "}
            </div>

            <div className="w-full flex flex-row items-center gap-2 mt-2 mt-[70px] pt-5 border-t border-[#ddd]">
              <Button
                variant="solid"
                className="w-full sm:w-[230px] rounded-[10px] font-manrope text-[16px] font-bold leading-[24px] h-[56px] bg-[#BCBEAD] hover:bg-light-600"
                onClick={onCancel}
              >
                Cancel
              </Button>
              <Button
                variant="validate"
                type="submit"
                className="w-full sm:w-[230px] rounded-[10px] font-manrope text-[16px] font-bold leading-[24px] h-[56px]"
                disabled={!isValid || isLoadingCreate || isLoadingUpdate}
                isLoading={isLoadingCreate || isLoadingUpdate}
              >
                {isNew ? "Save" : "Update"}
              </Button>
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default ServiceFormPage;

const Icon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 12C17 13.7 15.7 15 14 15C12.3 15 11 13.7 11 12C11 10.3 12.3 9 14 9C15.7 9 17 10.3 17 12ZM22 7V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V7C2 5.9 2.9 5 4 5V4H8V5H10L11 3H17L18 5H20C21.1 5 22 5.9 22 7ZM7.5 9C7.5 8.2 6.8 7.5 6 7.5C5.2 7.5 4.5 8.2 4.5 9C4.5 9.8 5.2 10.5 6 10.5C6.8 10.5 7.5 9.8 7.5 9ZM19 12C19 9.2 16.8 7 14 7C11.2 7 9 9.2 9 12C9 14.8 11.2 17 14 17C16.8 17 19 14.8 19 12Z"
      fill="black"
    />
  </svg>
);
